import classNames from 'classnames';
import PropTypes from 'prop-types';

import { useStyles } from './index.styles';

const CardTitle = ({
  children,
  className,
  tag: Tag = 'h3'
}) => {
  const classes = useStyles();

  return (
    <Tag
      className={classNames(classes.card__title, className)}
      data-testid="card-title"
    >
      {children}
    </Tag>
  );
};

CardTitle.propTypes = {
  /** The content of the component. */
  children: PropTypes.node.isRequired,
  /** Override or extend the styles applied to the component. */
  className: PropTypes.string,
  /** Change the wrapping elements tag. */
  tag: PropTypes.elementType
};

export default CardTitle;
